import React from 'react'
import cns from 'classnames'

import s from './NFCSFormPartSteps.module.scss'

type Props = {
  activeStepIndex: number
  stepsCount: number
  onStepClick?: (stepIndex: number) => void
}

export const NFCSFormPartSteps = (props: Props) => {
  const { activeStepIndex, stepsCount, onStepClick } = props

  return (
    <div className={s.wrap}>
      {Array.from(Array(stepsCount)).map((e, index) => {
        const isClickable = index < activeStepIndex && !!onStepClick
        return (
          <React.Fragment key={index}>
            <button
              onClick={isClickable ? () => onStepClick(index) : undefined}
              className={cns(s.step, {
                [s.isActive]: activeStepIndex === index,
                [s.isClickable]: isClickable,
              })}
            >
              {index + 1}
            </button>
            {index !== stepsCount - 1 && <div className={s.divider} />}
          </React.Fragment>
        )
      })}
    </div>
  )
}
